const LATIN_TO_ARABIC_DIGRAPHS = [
  ["sh", "ش"],
  ["kh", "خ"],
  ["gh", "غ"],
  ["th", "ث"],
  ["dh", "ذ"],
  ["ch", "تش"],
  ["ph", "ف"],
  ["wh", "و"],
  ["ng", "نغ"],
  ["ny", "ني"],
  ["qu", "كو"],
];

const LATIN_TO_ARABIC_CHARS = {
  a: "ا",
  b: "ب",
  c: "ك",
  d: "د",
  e: "ي",
  f: "ف",
  g: "گ",
  h: "ه",
  i: "ي",
  j: "ج",
  k: "ك",
  l: "ل",
  m: "م",
  n: "ن",
  o: "و",
  p: "پ",
  q: "ق",
  r: "ر",
  s: "س",
  t: "ت",
  u: "و",
  v: "ڤ",
  w: "و",
  x: "كس",
  y: "ي",
  z: "ز",
};

const LATIN_TO_TIGRINYA_DIGRAPHS = [
  ["sh", "ሽ"],
  ["ch", "ች"],
  ["kh", "ኽ"],
  ["gh", "ግ"],
  ["ph", "ፍ"],
  ["th", "ት"],
  ["dh", "ድ"],
  ["ng", "ንግ"],
  ["ny", "ንይ"],
  ["qu", "ቍ"],
];

const LATIN_TO_TIGRINYA_CHARS = {
  a: "ኣ",
  b: "ብ",
  c: "ክ",
  d: "ድ",
  e: "ኢ",
  f: "ፍ",
  g: "ግ",
  h: "ህ",
  i: "ኢ",
  j: "ጅ",
  k: "ክ",
  l: "ል",
  m: "ም",
  n: "ን",
  o: "ኦ",
  p: "ፕ",
  q: "ቕ",
  r: "ር",
  s: "ስ",
  t: "ት",
  u: "ኡ",
  v: "ቭ",
  w: "ው",
  x: "ክስ",
  y: "ይ",
  z: "ዝ",
};

const ARABIC_TO_LATIN_CHARS = {
  ا: "a",
  أ: "a",
  إ: "i",
  آ: "a",
  ب: "b",
  پ: "p",
  ت: "t",
  ث: "th",
  ج: "j",
  ح: "h",
  خ: "kh",
  د: "d",
  ذ: "dh",
  ر: "r",
  ز: "z",
  س: "s",
  ش: "sh",
  ص: "s",
  ض: "d",
  ط: "t",
  ظ: "z",
  ع: "a",
  غ: "gh",
  ف: "f",
  ڤ: "v",
  ق: "q",
  ك: "k",
  گ: "g",
  ل: "l",
  م: "m",
  ن: "n",
  ه: "h",
  و: "o",
  ي: "y",
  ى: "a",
  ة: "a",
  ؤ: "o",
  ئ: "i",
};

const TIGRINYA_TO_LATIN_CHARS = {
  ሀ: "ha",
  ሁ: "hu",
  ሂ: "hi",
  ሃ: "ha",
  ሄ: "he",
  ህ: "h",
  ሆ: "ho",
  ለ: "la",
  ሉ: "lu",
  ሊ: "li",
  ላ: "la",
  ሌ: "le",
  ል: "l",
  ሎ: "lo",
  መ: "ma",
  ሙ: "mu",
  ሚ: "mi",
  ማ: "ma",
  ሜ: "me",
  ም: "m",
  ሞ: "mo",
  ረ: "ra",
  ሩ: "ru",
  ሪ: "ri",
  ራ: "ra",
  ሬ: "re",
  ር: "r",
  ሮ: "ro",
  ሰ: "sa",
  ሱ: "su",
  ሲ: "si",
  ሳ: "sa",
  ሴ: "se",
  ስ: "s",
  ሶ: "so",
  ሸ: "sha",
  ሹ: "shu",
  ሺ: "shi",
  ሻ: "sha",
  ሼ: "she",
  ሽ: "sh",
  ሾ: "sho",
  ቀ: "qa",
  ቁ: "qu",
  ቂ: "qi",
  ቃ: "qa",
  ቄ: "qe",
  ቅ: "q",
  ቆ: "qo",
  ቐ: "qa",
  ቑ: "qu",
  ቒ: "qi",
  ቓ: "qa",
  ቔ: "qe",
  ቕ: "q",
  ቖ: "qo",
  በ: "ba",
  ቡ: "bu",
  ቢ: "bi",
  ባ: "ba",
  ቤ: "be",
  ብ: "b",
  ቦ: "bo",
  ቨ: "va",
  ቩ: "vu",
  ቪ: "vi",
  ቫ: "va",
  ቬ: "ve",
  ቭ: "v",
  ቮ: "vo",
  ተ: "ta",
  ቱ: "tu",
  ቲ: "ti",
  ታ: "ta",
  ቴ: "te",
  ት: "t",
  ቶ: "to",
  ቸ: "cha",
  ቹ: "chu",
  ቺ: "chi",
  ቻ: "cha",
  ቼ: "che",
  ች: "ch",
  ቾ: "cho",
  ኀ: "kha",
  ኁ: "khu",
  ኂ: "khi",
  ኃ: "kha",
  ኄ: "khe",
  ኅ: "kh",
  ኆ: "kho",
  ነ: "na",
  ኑ: "nu",
  ኒ: "ni",
  ና: "na",
  ኔ: "ne",
  ን: "n",
  ኖ: "no",
  ኘ: "nya",
  ኙ: "nyu",
  ኚ: "nyi",
  ኛ: "nya",
  ኜ: "nye",
  ኝ: "ny",
  ኞ: "nyo",
  አ: "a",
  ኡ: "u",
  ኢ: "i",
  ኣ: "a",
  ኤ: "e",
  እ: "e",
  ኦ: "o",
  ከ: "ka",
  ኩ: "ku",
  ኪ: "ki",
  ካ: "ka",
  ኬ: "ke",
  ክ: "k",
  ኮ: "ko",
  ኸ: "kha",
  ኹ: "khu",
  ኺ: "khi",
  ኻ: "kha",
  ኼ: "khe",
  ኽ: "kh",
  ኾ: "kho",
  ወ: "wa",
  ዉ: "wu",
  ዊ: "wi",
  ዋ: "wa",
  ዌ: "we",
  ው: "w",
  ዎ: "wo",
  ዐ: "a",
  ዑ: "u",
  ዒ: "i",
  ዓ: "a",
  ዔ: "e",
  ዕ: "e",
  ዖ: "o",
  ዘ: "za",
  ዙ: "zu",
  ዚ: "zi",
  ዛ: "za",
  ዜ: "ze",
  ዝ: "z",
  ዞ: "zo",
  ዠ: "zha",
  ዡ: "zhu",
  ዢ: "zhi",
  ዣ: "zha",
  ዤ: "zhe",
  ዥ: "zh",
  ዦ: "zho",
  የ: "ya",
  ዩ: "yu",
  ዪ: "yi",
  ያ: "ya",
  ዬ: "ye",
  ይ: "y",
  ዮ: "yo",
  ደ: "da",
  ዱ: "du",
  ዲ: "di",
  ዳ: "da",
  ዴ: "de",
  ድ: "d",
  ዶ: "do",
  ጀ: "ja",
  ጁ: "ju",
  ጂ: "ji",
  ጃ: "ja",
  ጄ: "je",
  ጅ: "j",
  ጆ: "jo",
  ገ: "ga",
  ጉ: "gu",
  ጊ: "gi",
  ጋ: "ga",
  ጌ: "ge",
  ግ: "g",
  ጎ: "go",
  ጠ: "ta",
  ጡ: "tu",
  ጢ: "ti",
  ጣ: "ta",
  ጤ: "te",
  ጥ: "t",
  ጦ: "to",
  ጨ: "cha",
  ጩ: "chu",
  ጪ: "chi",
  ጫ: "cha",
  ጬ: "che",
  ጭ: "ch",
  ጮ: "cho",
  ጰ: "pa",
  ጱ: "pu",
  ጲ: "pi",
  ጳ: "pa",
  ጴ: "pe",
  ጵ: "p",
  ጶ: "po",
  ጸ: "tsa",
  ጹ: "tsu",
  ጺ: "tsi",
  ጻ: "tsa",
  ጼ: "tse",
  ጽ: "ts",
  ጾ: "tso",
  ፀ: "tsa",
  ፁ: "tsu",
  ፂ: "tsi",
  ፃ: "tsa",
  ፄ: "tse",
  ፅ: "ts",
  ፆ: "tso",
  ፈ: "fa",
  ፉ: "fu",
  ፊ: "fi",
  ፋ: "fa",
  ፌ: "fe",
  ፍ: "f",
  ፎ: "fo",
  ፐ: "pa",
  ፑ: "pu",
  ፒ: "pi",
  ፓ: "pa",
  ፔ: "pe",
  ፕ: "p",
  ፖ: "po",
};

function transliterateWord(word, digraphs, chars) {
  let source = String(word || "").toLowerCase();
  let result = "";
  let index = 0;

  while (index < source.length) {
    let segment = null;

    for (const [latin, rendered] of digraphs) {
      if (source.startsWith(latin, index)) {
        segment = [latin, rendered];
        break;
      }
    }

    if (segment) {
      result += segment[1];
      index += segment[0].length;
      continue;
    }

    const char = source[index];
    result += chars[char] || source[index];
    index += 1;
  }

  return result;
}

function transliterateByWord(value, transliterator) {
  return String(value || "").replace(/[A-Za-z]+/g, (word) => transliterator(word));
}

const LOCATION_WORD_TRANSLATIONS = {
  ar: {
    airport: "\u0627\u0644\u0645\u0637\u0627\u0631",
    apartments: "\u0634\u0642\u0642",
    area: "\u0645\u0646\u0637\u0642\u0629",
    avenue: "\u0634\u0627\u0631\u0639",
    behind: "\u062e\u0644\u0641",
    beside: "\u0628\u062c\u0627\u0646\u0628",
    block: "\u0628\u0644\u0648\u0643",
    bridge: "\u0627\u0644\u062c\u0633\u0631",
    building: "\u0645\u0628\u0646\u0649",
    center: "\u0627\u0644\u0645\u0631\u0643\u0632",
    centre: "\u0627\u0644\u0645\u0631\u0643\u0632",
    church: "\u0627\u0644\u0643\u0646\u064a\u0633\u0629",
    close: "\u0642\u0631\u064a\u0628 \u0645\u0646",
    compound: "\u0645\u062c\u0645\u0639",
    corner: "\u0632\u0627\u0648\u064a\u0629",
    district: "\u062d\u064a",
    gate: "\u0627\u0644\u0628\u0648\u0627\u0628\u0629",
    hai: "\u062d\u064a",
    hospital: "\u0627\u0644\u0645\u0633\u062a\u0634\u0641\u0649",
    hotel: "\u0641\u0646\u062f\u0642",
    in: "\u0641\u064a",
    junction: "\u062a\u0642\u0627\u0637\u0639",
    landmark: "\u0645\u0639\u0644\u0645",
    market: "\u0627\u0644\u0633\u0648\u0642",
    mosque: "\u0627\u0644\u0645\u0633\u062c\u062f",
    near: "\u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646",
    nearby: "\u0642\u0631\u064a\u0628 \u0645\u0646",
    next: "\u0628\u062c\u0648\u0627\u0631",
    opposite: "\u0645\u0642\u0627\u0628\u0644",
    phase: "\u0645\u0631\u062d\u0644\u0629",
    plot: "\u0642\u0637\u0639\u0629",
    residence: "\u0633\u0643\u0646",
    residential: "\u0633\u0643\u0646\u064a",
    road: "\u0637\u0631\u064a\u0642",
    roundabout: "\u062f\u0648\u0627\u0631",
    school: "\u0645\u062f\u0631\u0633\u0629",
    street: "\u0634\u0627\u0631\u0639",
    the: "",
    tower: "\u0628\u0631\u062c",
    university: "\u0627\u0644\u062c\u0627\u0645\u0639\u0629",
  },
  ti: {
    airport: "\u1218\u12d5\u1228\u134d \u1290\u1348\u122d\u1272",
    apartments: "\u12a3\u1353\u122d\u1275\u121b\u1295\u1273\u1275",
    area: "\u12de\u1263",
    avenue: "\u130e\u12f0\u1293",
    behind: "\u12f5\u1215\u122a",
    beside: "\u130e\u12f5\u1292",
    block: "\u1265\u120e\u12ad",
    bridge: "\u12f5\u120d\u12f5\u120d",
    building: "\u1205\u1295\u1343",
    center: "\u121b\u12a5\u12a8\u120d",
    centre: "\u121b\u12a5\u12a8\u120d",
    church: "\u1264\u1270 \u12ad\u122d\u1235\u1272\u12eb\u1295",
    close: "\u1240\u1228\u1263",
    compound: "\u130d\u1262",
    corner: "\u12a9\u122d\u1293\u12d5",
    district: "\u12de\u1263",
    gate: "\u12f0\u1308",
    hai: "\u12ad\u134d\u1208 \u12a8\u1270\u121b",
    hospital: "\u1206\u1235\u1352\u1273\u120d",
    hotel: "\u1206\u1274\u120d",
    in: "\u12cd\u123d\u1322",
    junction: "\u1218\u122b\u12a8\u1262",
    landmark: "\u121d\u120d\u12ad\u1275",
    market: "\u12d5\u12f3\u130b",
    mosque: "\u1218\u1235\u130a\u12f5",
    near: "\u1240\u1228\u1263",
    nearby: "\u1240\u1228\u1263",
    next: "\u12a3\u1265 \u1325\u1243",
    phase: "\u121d\u12d5\u122b\u134d",
    plot: "\u1270\u1218\u12f3\u12f2\u1265 \u1218\u1228\u1275",
    residence: "\u1218\u1295\u1260\u122a",
    residential: "\u1218\u1295\u1260\u122a \u12d8\u1208\u12ce",
    road: "\u130e\u12f0\u1293",
    roundabout: "\u12d9\u122d\u12eb \u1218\u1295\u1308\u12f2",
    school: "\u1264\u1275 \u1275\u121d\u1205\u122d\u1272",
    street: "\u130e\u12f0\u1293",
    the: "",
    tower: "\u130d\u121d\u1262",
    university: "\u12e9\u1292\u1268\u122d\u1232\u1272",
  },
};

function getTransliterator(language) {
  if (language === "ar") {
    return (word) =>
      transliterateWord(word, LATIN_TO_ARABIC_DIGRAPHS, LATIN_TO_ARABIC_CHARS);
  }

  if (language === "ti") {
    return (word) =>
      transliterateWord(
        word,
        LATIN_TO_TIGRINYA_DIGRAPHS,
        LATIN_TO_TIGRINYA_CHARS,
      );
  }

  return null;
}

function shouldTransliterateLocationWord(word) {
  return /^[A-Z]/.test(word) || /^[A-Z][A-Za-z'-]*$/.test(word);
}

export function translateLocationTextForLanguage(value, language) {
  const sourceText = String(value || "").trim();

  if (!sourceText || (language !== "ar" && language !== "ti")) {
    return sourceText;
  }

  const wordTranslations = LOCATION_WORD_TRANSLATIONS[language] || {};
  const transliterator = getTransliterator(language);

  return sourceText
    .replace(/[A-Za-z]+/g, (word) => {
      const translatedWord = wordTranslations[word.toLowerCase()];

      if (typeof translatedWord === "string") {
        return translatedWord;
      }

      if (transliterator && shouldTransliterateLocationWord(word)) {
        return transliterator(word);
      }

      return word;
    })
    .replace(/\s{2,}/g, " ")
    .replace(/\s+([,./)])/g, "$1")
    .replace(/([(])\s+/g, "$1")
    .trim();
}

export function transliterateForLanguage(value, language) {
  if (!value) {
    return "";
  }

  if (language === "ar") {
    return transliterateByWord(value, (word) =>
      transliterateWord(word, LATIN_TO_ARABIC_DIGRAPHS, LATIN_TO_ARABIC_CHARS),
    );
  }

  if (language === "ti") {
    return transliterateByWord(value, (word) =>
      transliterateWord(word, LATIN_TO_TIGRINYA_DIGRAPHS, LATIN_TO_TIGRINYA_CHARS),
    );
  }

  return String(value || "");
}

export function transliterateToLatin(value) {
  return Array.from(String(value || ""))
    .map((char) => {
      if (ARABIC_TO_LATIN_CHARS[char]) {
        return ARABIC_TO_LATIN_CHARS[char];
      }

      if (TIGRINYA_TO_LATIN_CHARS[char]) {
        return TIGRINYA_TO_LATIN_CHARS[char];
      }

      return char;
    })
    .join("");
}

function stripDiacritics(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function normalizePhoneticText(value) {
  return stripDiacritics(transliterateToLatin(value))
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

export function levenshteinDistance(left, right) {
  const a = String(left || "");
  const b = String(right || "");

  if (a === b) {
    return 0;
  }

  if (!a) {
    return b.length;
  }

  if (!b) {
    return a.length;
  }

  const matrix = Array.from({ length: b.length + 1 }, (_, row) => [row]);

  for (let column = 0; column <= a.length; column += 1) {
    matrix[0][column] = column;
  }

  for (let row = 1; row <= b.length; row += 1) {
    for (let column = 1; column <= a.length; column += 1) {
      const cost = a[column - 1] === b[row - 1] ? 0 : 1;

      matrix[row][column] = Math.min(
        matrix[row - 1][column] + 1,
        matrix[row][column - 1] + 1,
        matrix[row - 1][column - 1] + cost,
      );
    }
  }

  return matrix[b.length][a.length];
}

export function similarityScore(left, right) {
  const a = normalizePhoneticText(left);
  const b = normalizePhoneticText(right);

  if (!a && !b) {
    return 1;
  }

  if (!a || !b) {
    return 0;
  }

  const longest = Math.max(a.length, b.length);
  return 1 - levenshteinDistance(a, b) / longest;
}
